import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import backRed from "../../../assets/svg/back-rose-icon.svg";
import Breadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import SucessModal from "../../../components/Modal/SucessModal";
import "./positionform.scss";

const PositionForm = ({ edit = false }) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const { id } = useParams();
  const [fields, setFields] = useState({});
  const [checked, setChecked] = useState(true);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const onSubmit = (fields) => {
    let updatedFileds = {
      ...fields,
      active: fields.active,
      status: fields.status,
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}career-add-position/create`,
        updatedFileds
      )
      .then((response) => {
        if (response.data?._id) {
          setSuccess(true);
        } else {
          alert("Fail");
          console.log("failed...");
        }
      });
  };

  const [data, setData] = useState([]);

  useEffect(() => {
    getDepartment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDepartment = (fields) => {
    axios
      .post(`${process.env.REACT_APP_API_URL}career-add-department/list`)
      .then((res) => {
        setData(res.data.rows);
      });
  };

  const breadcrumbsList = useMemo(
    () => [
      { text: "Careers", link: "/careers" },
      {
        text: edit
          ? "Edit Position / Designation"
          : "Add Position / Designation",
        link: "",
      },
    ],
    []
  );

  const handleUpdateData = () => {
    let item = {
      ...fields,
      functionName1: fields.functionName1,
      functionName2: fields.functionName2,
      active: fields.active,
    };
    fetch(`${process.env.REACT_APP_API_URL}career-add-position/update/${id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    }).then((result) => {
      result.json().then((resp) => {
        setSuccess(true);
      });
    });
  };

  const getpositionData = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}career-add-position/get/${id}`)
      .then((response) => {
        setFields(response.data);
      })
      .catch((err) => {
        console.error(err);
        alert("Some error");
      });
  };

  useEffect(() => {
    edit && getpositionData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Breadcrumbs
        className="w-75 healthsyMasterBreadCrumbs"
        breadcrumbsList={breadcrumbsList}
      />
      {/* <Home> */}
      <div
        onClick={() => navigate("/careerposition")}
        className="rose back-button"
      >
        <img src={backRed} alt="" />
        <span className="rose-back">Back</span>
      </div>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          edit ? handleUpdateData(fields) : onSubmit(fields);
        }}
        className="carr-pos-form"
      >
        <div className="row car-pos-form">
          <div className="col-5">
            <label htmlFor="" className=" small mb-3">
              Select Department /Function Name <span className="star">*</span>
            </label>
            <select
              className="form-control w-75 "
              name=""
              id="functionName1"
              value={fields.functionName1}
              onChange={(e) =>
                setFields((prevState) => {
                  return { ...prevState, functionName1: e.target.value };
                })
              }
            >
              <option>Select</option>
              {/* <option value={fields.functionName1}>
                {fields.functionName1}
              </option>
              <option>Engineering</option>
              <option>Designing</option>
              <option>Sales</option> */}

              {data.map((dept) => (
                <option key={dept._id} value={dept.department}>
                  {dept.department}
                </option>
              ))}
            </select>
            {errors.functionName1 && (
              <div className={`invalid-feedback d-block`}>
                Please Select an Option
              </div>
            )}
          </div>
          <div className="col-5">
            <label htmlFor="" className=" small mb-3">
              Type Department /Function Name <span className="star">*</span>
            </label>
            <input
              type="text"
              placeholder="Type here.."
              className="form-control w-75"
              name=""
              id="functionName2"
              value={fields.functionName2}
              onChange={(e) =>
                setFields((prevState) => {
                  return { ...prevState, functionName2: e.target.value };
                })
              }
            />
            {errors.functionName2 && (
              <div className={`invalid-feedback d-block`}>
                Please Enter Department
              </div>
            )}
          </div>
        </div>
        <div className="row mt-3">
          <div className="col">
            <label className=" small mb-2" htmlFor="">
              Status <span className="star">*</span>
            </label>
            <div className="d-flex">
              <div className="form-check form-check-inline me-3 mt-1">
                <input
                  className="form-check-input me-3"
                  type="radio"
                  name="status"
                  id="status"
                  onChange={(e) => {
                    setFields((prevState) => {
                      return { ...prevState, active: true, status: "Active" };
                    });
                  }}
                  value={true}
                  checked={fields.active === true ? "checked" : null}
                />
                <label htmlFor="option-1" className="text-dark mt-1">
                  Active
                </label>
              </div>
              <div className="form-check form-check-inline mt-1">
                <input
                  className="form-check-input  me-3"
                  type="radio"
                  name="status"
                  id="status"
                  onChange={(e) => {
                    setFields((prevState) => {
                      return {
                        ...prevState,
                        active: false,
                        status: "Inactive",
                      };
                    });
                  }}
                  value={false}
                  checked={fields.active === false ? "checked" : null}
                />
                <label htmlFor="option-2" className="text-dark mt-1">
                  Inactive
                </label>
              </div>
            </div>
          </div>
          {errors.status && (
            <div className={`invalid-feedback d-block`}>
              Please Select an Option
            </div>
          )}
        </div>
        <div className="car-pos-form-button">
          <button type="submit">SUBMIT</button>
        </div>
      </form>
      {/* </Home> */}
      {success && (
        <SucessModal
          page={"/careerposition"}
          name="Career Position"
          post="posted"
        />
      )}
    </>
  );
};

export default PositionForm;
